import { cn } from '@massilia/ui'

import { FlightSearchForm } from '@/components/research-bar/-form-groups/flight-search-form'

interface ResearchBarFormShellProps {
  className?: string
}

export function ResearchBarFormShell({ className }: ResearchBarFormShellProps) {
  return (
    <div
      className={cn(
        'flex scale-95 flex-col items-start gap-8 rounded-lg bg-white p-4 shadow-xl md:scale-100 md:p-6',
        className
      )}
    >
      <FlightSearchForm />
    </div>
  )
}
